import { render, staticRenderFns } from "./SimpleLinkCard.vue?vue&type=template&id=06c1d03c&scoped=true&"
import script from "./SimpleLinkCard.vue?vue&type=script&lang=js&"
export * from "./SimpleLinkCard.vue?vue&type=script&lang=js&"
import style0 from "./SimpleLinkCard.vue?vue&type=style&index=0&id=06c1d03c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c1d03c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
